module.exports = __webpack_public_path__ + "img/pancake-hero.d16a53cf.png";